import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import ModernLogin from '../pages/ModernLogin';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import SsoCallback from '../pages/SsoCallback';
import ModernHome from '../pages/ModernHome';
import DashboardPage from '../pages/Dashboard';
import UsersPage from '../pages/Users';
import MenusPage from '../pages/Menus';
import MunicipiosPage from '../pages/Municipios';
import MunicipioFormPage from '../pages/MunicipioForm';
import PerfisPage from '../pages/Perfis';
import SettingsPage from '../pages/Settings';
import BiEditorPage from '../pages/BiEditorPage';
import ModernLayout from '../components/ModernLayout';
import SaudeDashboard from '../pages/saude/SaudeDashboard';
import SaudeEixo from '../pages/saude/SaudeEixo';
import SaudeListaNominal from '../pages/saude/SaudeListaNominal';
import SaudeRanking from '../pages/saude/SaudeRanking';
import SaudeFinanceiro from '../pages/saude/SaudeFinanceiro';
import SaudePainelMS from '../pages/saude/SaudePainelMS';
import SaudeCoberturaVacinal from '../pages/saude/SaudeCoberturaVacinal';
import SaudeQualidadeDados from '../pages/saude/SaudeQualidadeDados';
import SaudeDadosSociodemograficos from '../pages/saude/SaudeDadosSociodemograficos';
import SaudeAtendimentos24h from '../pages/saude/SaudeAtendimentos24h';
import SaudeFilasEspera from '../pages/saude/SaudeFilasEspera';
import SaudeFilasConsultorios from '../pages/saude/SaudeFilasConsultorios';
import SaudeIndicePrescricoes from '../pages/saude/SaudeIndicePrescricoes';
import SaudeOcupacaoLeitos from '../pages/saude/SaudeOcupacaoLeitos';
import SaudeProdutividade from '../pages/saude/SaudeProdutividade';
import SaudePesquisaSatisfacao from '../pages/saude/SaudePesquisaSatisfacao';
import SaudePrimeirosAtendimentos from '../pages/saude/SaudePrimeirosAtendimentos';
import SaudeProducaoAmbulatorial from '../pages/saude/SaudeProducaoAmbulatorial';
import SaudeEstatisticasInternacao from '../pages/saude/SaudeEstatisticasInternacao';
import SaudeTempoRegulacao from '../pages/saude/SaudeTempoRegulacao';
import SaudeAgendaDoDia from '../pages/saude/SaudeAgendaDoDia';
import SaudeResumoExecutivo from '../pages/saude/SaudeResumoExecutivo';
import SaudeRitmoVisitasAcs from '../pages/saude/SaudeRitmoVisitasAcs';
import SaudeEquipesSemProducao from '../pages/saude/SaudeEquipesSemProducao';
import SaudeFichasRascunho from '../pages/saude/SaudeFichasRascunho';
import SaudeProfissionaisDuplicados from '../pages/saude/SaudeProfissionaisDuplicados';
import SaudeCvat from '../pages/saude/SaudeCvat';
import SaudeCvatLista from '../pages/saude/SaudeCvatLista';
import MonitoramentoDashboard from '../pages/monitoramento/MonitoramentoDashboard';
import MonitoramentoLeitos from '../pages/monitoramento/MonitoramentoLeitos';
import MonitoramentoInternacoes from '../pages/monitoramento/MonitoramentoInternacoes';
import MonitoramentoTempos from '../pages/monitoramento/MonitoramentoTempos';
import MonitoramentoRegulacao from '../pages/monitoramento/MonitoramentoRegulacao';
import MonitoramentoFilaEspera from '../pages/monitoramento/MonitoramentoFilaEspera';
import MonitoramentoDispensacoes from '../pages/monitoramento/MonitoramentoDispensacoes';
import MonitoramentoCid from '../pages/monitoramento/MonitoramentoCid';
import MonitoramentoGeo from '../pages/monitoramento/MonitoramentoGeo';
import MonitoramentoPacientes from '../pages/monitoramento/MonitoramentoPacientes';
import MonitoramentoSuspensao from '../pages/monitoramento/MonitoramentoSuspensao';
import MonitoramentoIcsaps from '../pages/monitoramento/MonitoramentoIcsaps';
import MonitoramentoVacinas from '../pages/monitoramento/MonitoramentoVacinas';
import MonitoramentoDcnt from '../pages/monitoramento/MonitoramentoDcnt';
import MonitoramentoParametros from '../pages/monitoramento/MonitoramentoParametros';
import MonitoramentoVisa from '../pages/monitoramento/MonitoramentoVisa';
import MonitoramentoVisaGeo from '../pages/monitoramento/MonitoramentoVisaGeo';
import MonitoramentoVisaWeb from '../pages/monitoramento/MonitoramentoVisaWeb';
import MonitoramentoVisaWebDetalhes from '../pages/monitoramento/MonitoramentoVisaWebDetalhes';
import MonitoramentoVigilanciaEpidemiologica from '../pages/monitoramento/MonitoramentoVigilanciaEpidemiologica';
import MonitoramentoVigilanciaEpidemiologicaDetalhes from '../pages/monitoramento/MonitoramentoVigilanciaEpidemiologicaDetalhes';
import MonitoramentoMac from '../pages/monitoramento/MonitoramentoMac';
import MonitoramentoEquipamentos from '../pages/monitoramento/MonitoramentoEquipamentos';
import MonitoramentoFpo from '../pages/monitoramento/MonitoramentoFpo';
import MonitoramentoRepasses from '../pages/monitoramento/MonitoramentoRepasses';
import MonitoramentoUnidadesMoveis from '../pages/monitoramento/MonitoramentoUnidadesMoveis';
import Alertas from '../pages/Alertas';
import EspecializadaDashboard from "../pages/especializada/EspecializadaDashboard";import EspecializadaRede from "../pages/especializada/EspecializadaRede";import EspecializadaProspeccao from "../pages/especializada/EspecializadaProspeccao";import EspecializadaProducao from "../pages/especializada/EspecializadaProducao";import EspecializadaCustos from "../pages/especializada/EspecializadaCustos";import EspecializadaPredicao from "../pages/especializada/EspecializadaPredicao";import EspecializadaPlanejamento from "../pages/especializada/EspecializadaPlanejamento";
import IegmDashboard from "../pages/iegm/IegmDashboard";import IegmISaude from "../pages/iegm/IegmISaude";


const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();
  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const LoginRoute: React.FC = () => {
  const { isAuthenticated, isInitialized } = useAuth();
  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <ModernLogin />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/sso-callback" element={<SsoCallback />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <ModernLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<ModernHome />} />
        <Route path="dashboard/:submenuId" element={<DashboardPage />} />
        <Route path="usuarios" element={<UsersPage />} />
        <Route path="menus" element={<MenusPage />} />
        <Route path="municipios" element={<MunicipiosPage />} />
        <Route path="municipios/novo" element={<MunicipioFormPage />} />
        <Route path="municipios/:id" element={<MunicipioFormPage />} />
        <Route path="perfis" element={<PerfisPage />} />
        <Route path="configuracoes" element={<SettingsPage />} />
        <Route path="bi/editor" element={<BiEditorPage />} />
        <Route path="saude" element={<SaudeDashboard />} />
        <Route path="saude/ranking" element={<SaudeRanking />} />
        <Route path="saude/financeiro" element={<SaudeFinanceiro />} />
        <Route path="saude/painel-ms" element={<SaudePainelMS />} />
        <Route path="saude/cobertura-vacinal" element={<SaudeCoberturaVacinal />} />
        <Route path="saude/qualidade-dados" element={<SaudeQualidadeDados />} />
        <Route path="saude/dados-sociodemograficos" element={<SaudeDadosSociodemograficos />} />
        <Route path="saude/atendimentos-24h" element={<SaudeAtendimentos24h />} />
        <Route path="saude/filas-espera" element={<SaudeFilasEspera />} />
        <Route path="saude/filas-consultorios" element={<SaudeFilasConsultorios />} />
        <Route path="saude/indice-prescricoes" element={<SaudeIndicePrescricoes />} />
        <Route path="saude/ocupacao-leitos" element={<SaudeOcupacaoLeitos />} />
        <Route path="saude/produtividade" element={<SaudeProdutividade />} />
        <Route path="saude/pesquisa-satisfacao" element={<SaudePesquisaSatisfacao />} />
        <Route path="saude/primeiros-atendimentos" element={<SaudePrimeirosAtendimentos />} />
        <Route path="saude/producao-ambulatorial" element={<SaudeProducaoAmbulatorial />} />
        <Route path="saude/estatisticas-internacao" element={<SaudeEstatisticasInternacao />} />
        <Route path="saude/tempo-regulacao" element={<SaudeTempoRegulacao />} />
        <Route path="saude/relatorios/agenda-dia" element={<SaudeAgendaDoDia />} />
        <Route path="saude/relatorios/ritmo-visitas-acs" element={<SaudeRitmoVisitasAcs />} />
        <Route path="saude/relatorios/resumo-executivo" element={<SaudeResumoExecutivo />} />
        <Route path="saude/relatorios/equipes-sem-producao" element={<SaudeEquipesSemProducao />} />
            <Route path="saude/relatorios/fichas-rascunho" element={<SaudeFichasRascunho />} />
            <Route path="saude/relatorios/profissionais-duplicados" element={<SaudeProfissionaisDuplicados />} />
        {/* Rotas estaticas de /saude precisam vir ANTES do catch-all saude/:eixo */}
        <Route path="saude/cvat" element={<SaudeCvat />} />
        <Route path="saude/cvat/lista" element={<SaudeCvatLista />} />
        <Route path="saude/:eixo" element={<SaudeEixo />} />
        <Route path="saude/:eixo/lista" element={<SaudeListaNominal />} />
        <Route path="monitoramento" element={<MonitoramentoDashboard />} />
        <Route path="monitoramento/leitos" element={<MonitoramentoLeitos />} />
        <Route path="monitoramento/internacoes" element={<MonitoramentoInternacoes />} />
        <Route path="monitoramento/tempos-espera" element={<MonitoramentoTempos />} />
        <Route path="monitoramento/regulacao" element={<MonitoramentoRegulacao />} />
        <Route path="monitoramento/fila-espera" element={<MonitoramentoFilaEspera />} />
        <Route path="monitoramento/dispensacoes" element={<MonitoramentoDispensacoes />} />
        <Route path="monitoramento/cid" element={<MonitoramentoCid />} />
        <Route path="monitoramento/geo" element={<MonitoramentoGeo />} />
        <Route path="monitoramento/pacientes" element={<MonitoramentoPacientes />} />
        <Route path="monitoramento/suspensao" element={<MonitoramentoSuspensao />} />
        <Route path="monitoramento/icsaps" element={<MonitoramentoIcsaps />} />
        <Route path="monitoramento/vacinas" element={<MonitoramentoVacinas />} />
        <Route path="monitoramento/dcnt" element={<MonitoramentoDcnt />} />
        <Route path="monitoramento/parametros" element={<MonitoramentoParametros />} />
        <Route path="monitoramento/visa" element={<MonitoramentoVisa />} />
        <Route path="monitoramento/visa-geo" element={<MonitoramentoVisaGeo />} />
        <Route path="monitoramento/visa-web" element={<MonitoramentoVisaWeb />} />
        <Route path="monitoramento/visa-web/detalhes" element={<MonitoramentoVisaWebDetalhes />} />
        <Route path="monitoramento/vigilancia-epidemiologica" element={<MonitoramentoVigilanciaEpidemiologica />} />
        <Route path="monitoramento/vigilancia-epidemiologica/detalhes" element={<MonitoramentoVigilanciaEpidemiologicaDetalhes />} />
        <Route path="monitoramento/mac" element={<MonitoramentoMac />} />
        <Route path="monitoramento/equipamentos" element={<MonitoramentoEquipamentos />} />
        <Route path="monitoramento/fpo" element={<MonitoramentoFpo />} />
        <Route path="monitoramento/repasses" element={<MonitoramentoRepasses />} />
        <Route path="monitoramento/unidades-moveis" element={<MonitoramentoUnidadesMoveis />} />
        <Route path="iegm" element={<IegmDashboard />} />
        <Route path="iegm/isaude" element={<IegmISaude />} />
        <Route path="alertas" element={<Alertas />} />
        <Route path="especializada" element={<EspecializadaDashboard />} />        <Route path="especializada/rede" element={<EspecializadaRede />} />        <Route path="especializada/prospeccao" element={<EspecializadaProspeccao />} />        <Route path="especializada/producao" element={<EspecializadaProducao />} />        <Route path="especializada/custos" element={<EspecializadaCustos />} />        <Route path="especializada/predicao" element={<EspecializadaPredicao />} />        <Route path="especializada/planejamento" element={<EspecializadaPlanejamento />} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
